import { slugify } from '@/lib/helpers/common'

export default {
  methods: {
    buttonClasses({ size, style }) {
      return `btn btn-${slugify(size)} btn-${slugify(style)}`.toLowerCase()
    },
  },
}
